import { twMerge } from "tailwind-merge";
import type { TDotsButton } from "./types";

export const DotsButton = ({ className, active, onClick }: TDotsButton) => {
  const DotsButtonElement = document.createElement("button");
  DotsButtonElement.type = "button";
  DotsButtonElement.disabled = active;
  DotsButtonElement.className = twMerge(
    "w-2 h-2 bg-gray-150 cursor-pointer disabled:cursor-not-allowed disabled:bg-blue-500",
    className,
  );

  DotsButtonElement.addEventListener("click", onClick);

  return DotsButtonElement;
};
